
import { Component, Mixins, Prop, Watch} from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import BarcodeManufacturerModule from "@/store/modules/barcodeSystem/barcodeManufacturer";
import { ManufacturerResource } from "@/models/api/barcodeSystem/barcodeManufacturers/get";

const barcodeManufacturerModuleState = getModule(BarcodeManufacturerModule);

@Component({
  components: {
    Select
  }
})
export default class BarcodeManufacturerSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  @Prop({ default: false })
  appendToBody: boolean;
  @Prop()
  type: string;
  @Prop({ default: null })
  companyIds: number[];
  @Prop({ default: false })
  allowManualStockOrdersCreationOnly: boolean;
  localManufacturers: ManufacturerResource[] = null;

  get manufacturers()
  {
    return barcodeManufacturerModuleState.manufacturers;
  }

  created() {
    this.localManufacturers = JSON.parse(JSON.stringify(this.manufacturers));
  }

  get types() {
    let filtered = this.allowManualStockOrdersCreationOnly
      ? this.localManufacturers.filter(x => x.allowManualStockOrdersCreation)
      : this.localManufacturers;

    if(this.companyIds && this.companyIds.length > 0)
      return filtered.filter(x => x.companyIds.some(y => this.companyIds.includes(y))).map(x => ({ label: x.agentManufacturerCode ?? x.manufacturerName, value: x.code }));
    else
      return filtered.map(x => ({ label: x.agentManufacturerCode ?? x.manufacturerName, value: x.code }));
  }
}
